const initialState = {
  email: '',
  password: '',
  firstName: '',
  lastName: '',
  companyName: '',
  dateFormat: 'DD/MM/YYYY',
  bookingSystem: '',
  emailClient: '',
  companyId: '',
  userId: '',
  autoLoginLink: '',
  shouldSend3rdPartyEmail: false,
  checkingEmail: false,
  emailChecked: false,
  signingUp: false,
  signedUp: false,
  schedulesOpen: false,
  error: '',
  successMessage: '',
};


export default function BookingsAISignUp(state = initialState, { type, payload }) {
  switch(type) {
    case 'bookingsAISignUp_updateProps': {
      return {
        ...state,
        ...payload,
      }
    }
    case 'bookingsAISignUp_doEmailCheck': {
      return {
        ...state,
        checkingEmail: true,
      };
    }
    case 'bookingsAISignUp_doEmailCheck_SUCCESS': {
      return {
        ...state,
        userId: payload.userId,
        companyId: payload.companyId,
        checkingEmail: false,
        emailChecked: true,
        error: '',
      };
    }
    case 'bookingsAISignUp_doEmailCheck_ERROR': {
      return {
        ...state,
        checkingEmail: false,
        emailChecked: false,
        error: payload,
      };
    }
    case 'bookingsAISignUp_doSignUp': {
      return {
        ...state,
        signingUp: true,
      };
    }
    case 'bookingsAISignUp_doSignUp_SUCCESS': {
      return {
        ...state,
        signingUp: false,
        signedUp: Boolean(payload.companyId),
        error: payload.companyId ? '' : state.error,
        autoLoginLink: payload.autoLoginLink || '',
      };
    }
    case 'bookingsAISignUp_doSignUp_ERROR': {
      return {
        ...state,
        signingUp: false,
        signedUp: false,
        error: 'There is an error, please try again or contact support@tourconnect.com.',
      };
    }
    case 'bookingsAISignUp_openMeetingSchedules': {
      return {
        ...state,
        schedulesOpen: true,
      };
    }
    case 'bookingsAISignUp_successMessage':
      return {
        ...state,
        successMessage: payload,
      };
    default:
      return state;
  }
}